import * as constants from './constants'

export const setSelectedCamera = value => ({
  type: constants.SELECTED_CAMERA,
  value
})

export const setScreenPow = value => ({
  type: constants.SET_SCREEN_POW,
  value
})

export const setScreenPage = value => ({
  type: constants.SET_SCREEN_PAGE,
  value
})
